module.exports = __webpack_public_path__ + "static/media/serach.4e455070.svg";